<template>
<div id="contents">

  <div id="works" class="page_contents">
    <div class="page_header">
      <h1 class="page_header_title">
        <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
        <span>制作実績</span>
      </h1><!-- .top_sec_title -->

      <worksPageNav/>

      <div class="page_selector">
        <h3 v-on:click="show_category_box">{{ select_category_name }}</h3>
        <div v-show="category_box" class="page_selector_box">
          <ul>
            <li v-for="category in categories" :key="category.term_id"><a href="" v-on:click="slect_category" v-bind:data="category.term_id" v-bind:name="category.name">{{ category.name }}</a></li>
          </ul>
        </div><!-- .header_selector_box -->
      </div><!-- .page_header_selector -->


    </div><!-- .page_header -->

    <div id="works_contents">
      <div id="works_program_index">

        <div id="works_program_index_list">
          <transition-group tag="ul">
            <li v-for="program in program_list" :key="program.post_id"><router-link v-bind:to="{name: 'works_program_show', params: {id: program.post_id}}" class="hover"><img :src="program.kv_image" width="286" alt="番組のロゴ" /></router-link></li>
          </transition-group>
        </div><!-- #works_program_index_list -->

      </div><!-- #works_program_index -->
    </div><!-- #works_contents -->

  </div><!-- #works -->

</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'players_index',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/program/index.php',
      api_category_url: this.$parent.api_base_url+'/api/program/fetch_category.php',
      loading: false,
      category_box: false,
      categories: null,
      select_category: 0,
      select_category_name: 'ジャンルで見る',
      program_list: null,
      error: null
    }
  },
  components: {
    worksPageNav
  },
  methods: {
    show_category_box(){
      if(!this.category_box){
        this.category_box = true
      }
    },
    slect_category(event){
      const term_id = event.target.getAttribute('data')
      const name = event.target.getAttribute('name')
      this.select_category = term_id
      this.select_category_name = name
      this.fetch_program_list()
      this.category_box = false
      event.preventDefault()
    },
    fetch_category_list(){
      this.$axios
        .get(this.api_category_url)
        .then(response => {
          this.categories = response.data.categories
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    fetch_program_list(){
      this.$axios
        .get(this.api_url,{
          params: {
            term_id: this.select_category
          }
        })
        .then(response => {
          this.program_list = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    }
  },
  mounted () {
    this.fetch_category_list()
    this.fetch_program_list()
  }
}
</script>

<style scoped lang="sass">
  #works_program_index_list ul li a
    display: block
    position: relative
    width: 286px
    height: 166px
    overflow: hidden
    margin: 0 auto
    img
      position: absolute
      bottom: 0
      left: 0


</style>



// WEBPACK FOOTER //
// src/components/program_index.vue